// Actions
export const setEvents = ({ commit }, payload) => {
  commit('SET_EVENTS', payload)
}
export const addEvents = ({ commit }, payload) => {
  commit('ADD_EVENTS', payload)
}
export const setEventsLoading = ({ commit }, payload) => {
  commit('SET_EVENTS_LOADING', payload)
}

export const setProspects = ({ commit }, payload) => {
  commit('SET_PROSPECTS', payload)
}
export const addProspects = ({ commit }, payload) => {
  commit('ADD_PROSPECTS', payload)
}
export const setProspectsLoading = ({ commit }, payload) => {
  commit('SET_PROSPECTS_LOADING', payload)
}

